import {
	feedbackIntegration,
	init,
	reactErrorHandler,
	replayIntegration,
	tanstackRouterBrowserTracingIntegration,
} from "@sentry/react";
import type { Register } from "@tanstack/react-router";
import type { RootOptions } from "react-dom/client";
import { env } from "@/env.ts";
import packageJson from "../../package.json";

export const initSentry = ({ router }: { router: Register["router"] }) => {
	init({
		enabled: !!env.VITE_SENTRY_DSN,
		release: packageJson.version,
		dsn: env.VITE_SENTRY_DSN,
		tunnel: "/api/sentry-tunnel",
		environment: env.VITE_SENTRY_ENVIRONMENT,
		// Adds request headers and IP for users, for more info visit:
		// https://docs.sentry.io/platforms/javascript/guides/react/configuration/options/#sendDefaultPii
		sendDefaultPii: true,
		integrations: [
			replayIntegration(),
			feedbackIntegration({
				// Additional SDK configuration goes in here, for example:
				colorScheme: "system",
			}),
			tanstackRouterBrowserTracingIntegration(router),
		],
		// Enable logs to be sent to Sentry
		enableLogs: true,
		// Capture Replay for 10% of all sessions,
		// plus for 100% of sessions with an error
		// Learn more at
		// https://docs.sentry.io/platforms/javascript/session-replay/configuration/#general-integration-configuration
		replaysSessionSampleRate: 0.1,
		replaysOnErrorSampleRate: 1.0,
		debug: import.meta.env.DEV,
	});
};

export const captureReactErrors: RootOptions = {
	onUncaughtError: reactErrorHandler((error, errorInfo) => {
		// biome-ignore lint/suspicious/noConsole: Debug purposes
		console.warn("Uncaught error", error, errorInfo.componentStack);
	}),
	onCaughtError: reactErrorHandler(),
	onRecoverableError: reactErrorHandler(),
};
